if ($('#app-post-centro-table').length) {

    var progress_loader_steps = 0;
    var progress_loader_curr_step = 0;
    var update_progress_loader = function (message, steps) {
        var container = $('#progressloader');

        progress_loader_curr_step++;
        width = (progress_loader_curr_step / progress_loader_steps) * 100;
        container.find('.progress-bar').attr('aria-valuenow', width).css('width', width.toString() + '%');
        if (steps === true) {
            message = message + ' (' + progress_loader_curr_step + ' of ' + progress_loader_steps + ')';
        }
        container.find('span').html(message + '...');
        if(progress_loader_steps <= progress_loader_curr_step)
            close_progress_loader();
    };

    var init_progress_loader = function (steps, message) {
        progress_loader_steps = steps;
        progress_loader_curr_step = 0;

        update_progress_loader(message);

        $('#progressloader').show();
    };

    var close_progress_loader = function () {
        progress_loader_steps = 0;
        progress_loader_curr_step = 0;
        $('#progressloader').hide();
    };

    var app_post_centro_table = $('#app-post-centro-table').DataTable({
        order: [4, "desc"],
        columns: [
            {data: 'id'},//0
            {data: 'name'},//1
            {data: 'advertiser_name'},//2
            {data: 'campaign_name'},//3
            {data: 'created_at'},//4
            {data: 'id'}//5
        ],
        destroy: true,
        pageLength: user_entries,
        "columnDefs": [
            {
                "targets": 0,
                "visible": false,
            },
            {
                "targets": 4,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
                    $(td).html(date.format('MM/DD/YYYY'));
                }
            },
            {
                "targets": 5,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                        '<a href="javascript:void(0)" role="button" class="btn btn-info btn-sm report-view" data-id="'+cellData+'">' +
                        '<i class="fa fa-eye"></i> View' +
                        '</a>' +
                        '<a href="/post/centro/edit/configuration/' + cellData +' "  class="btn btn-success btn-sm btn-disabled edit-report " role="button">' +
                        '<i class="fa fa-pencil"></i> Edit' +
                        '</a>' +
                        '</div>' +
                        '<a href="javascript:void(0)" class="btn btn-danger btn-sm btn-disabled delete-report" data-row="'+row+'" data-id="' + cellData + '" role="button">' +
                        '<i class="fa fa-trash-o"></i> Delete' +
                        '</a></div>';
                    $(td).html(html);
                }
            }
        ]
    });
    $('#app-post-centro-table').on('click', '.report-view', function () {
        show_loader();
        init_progress_loader(2, 'This query might take a few seconds. Please wait ...');
        var url= '/post/centro/report/view/'+ $(this).attr('data-id');
        var link = document.createElement('a');
        link.href = url;
        link.click();
    });
    $.ajax({
        type: 'GET',
        url: '/post/centro/list',
        dataType: 'json',
        encode: true,
        success: function (response) {
            app_post_centro_table.clear();
            app_post_centro_table.rows.add(response);
            app_post_centro_table.draw();
        },
        error: function (xhr) {
            ajax_error();
            debug(xhr.responseText);
        }
    });
    $('#app-post-centro-table').on('click', '.delete-report', function () {
        $.ajax({
            type: 'GET',
            url: '/post/centro/report/delete/'+  $(this).attr('data-id'),
            dataType: 'json',
            encode: true,
            success: function (response) {
                global_notification('success', 'Report deleted...');
                app_post_centro_table.row($(this).attr('data-row')).remove().draw();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
            }
        });
    });
}
